export const LOGIN = 'LOGIN'
export const LOGOUT = 'LOGOUT'
export const SENDTOKEN = 'SENDTOKEN'
/**
  * sendToken
  * @desc send Access Token action generator
  * @param {Number} token
  * @return {SendTokenAction} Action
*/
export function sendToken (token, subdomain) {
  const query = { token, subdomain }
  return { type: SENDTOKEN, query }
}
/**
  * login
  * @desc login action generator
  * @param {userDescription}  A user object passed from apprise in response to access token
  * @return {LoginAction} login action to store user info in the state
  */
export function login (user) {
  return { type: LOGIN, user }
}

/**
  * logout
  * @desc logout action generator
  * @return {LogoutAction} logout action to remove user info
*/
export function logout () {
  return { type: LOGOUT }
}
